import { render, staticRenderFns } from "./CerezPolitikasi.vue?vue&type=template&id=7f5d506e&scoped=true&"
import script from "./CerezPolitikasi.vue?vue&type=script&lang=js&"
export * from "./CerezPolitikasi.vue?vue&type=script&lang=js&"
import style0 from "./CerezPolitikasi.vue?vue&type=style&index=0&id=7f5d506e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5d506e",
  null
  
)

export default component.exports